import * as sonbpIfconst from "../../sonbpIf/base/constants";
import * as idbEdit from "../../entity/idb/editInfo";
import * as es6promise from "es6-promise";
import { Logger } from "../../util/logger";
import { GetEditInfo, util } from "../..";
import { constDialogMessage, dialogUtil } from "../../util";

import { EditConst, EDIT_MODE_KIND } from "../edit.const";
import { photoFrame, uploadPhoto } from "../edit.entity";
import { itemVenderProperty } from "../edit.sonbp_if";
import { UploadImageLogicClass } from "./edit.uploadImageLogic.base";
import { editStrage } from "../edit.tool";
import Enumerable from "linq";
import { data } from "jquery";


/**
 * 写真
 * 画像アップロード、画像配置の処理を提供するクラス
 */
export class PhotoLogicClass extends UploadImageLogicClass {

// #region ■定数

    /**
     * アップロード画像最大数
     * @override
     */
    protected readonly UPLOAD_IMAGE_NUM_MAX: number = 18;
    /**
     * 画像アップロード(WebAPI)呼び出しURL
     * @override
     */
    protected readonly WEBAPI_URL_UPLOADIMAGE: string = "Edit/UploadImage";
    /**
     * 画像サムネイル取得(WebAPI)呼び出しURL
     * @override
     */
    protected readonly WEBAPI_URL_GETTHUMBNAIL: string = "Edit/GetImage";
    /**
     * 明るさ変更(WebAPI)呼び出しURL
     */
    private readonly WEBAPI_URL_CHANGEBRIGHT: string = "Edit/ChangeBright";

    /**
     * 写真固有の動作必要か
     * @override
     */
    protected readonly _isPhotoFlg: boolean = true;

// #endregion

// #region ■プロパティ

    /**
     * アップロード画像最大数
     * @implements
     */
    public UploadNumMax(): number {

        if (util.verify.isNotEmpty(this._edctrl.ScreenCtrl.photoUlFileNumMax)) {
            return this._edctrl.ScreenCtrl.photoUlFileNumMax;
        }
        else {
            return this.UPLOAD_IMAGE_NUM_MAX;
        }
    }

// #endregion

// #region ■起動

    /**
     * アップロード情報の復元
     */
    public restoreUoloadPhotoList(isFromIdb: boolean, isUsed: boolean, idbEditInfo: idbEdit.editInfo, editInfo: GetEditInfo.GetEditInfoResponseEntity) {

        this.restoreUoloadList(isFromIdb, isUsed, idbEditInfo?.photoList, editInfo.info.photo);

        if (isFromIdb && idbEditInfo && idbEditInfo.photoList) {

            // 枠情報をindexDBの情報で復元
            editInfo.info.photoUse = [];
            if (idbEditInfo.photoUseList) {
                for (let i: number = 0; i < idbEditInfo.photoUseList.length; i++) {
                    if (idbEditInfo.photoUseList[i].fileId) {
                        const photoUse = new GetEditInfo.GetEditInfoPhotoUseEntity();
                        photoUse.fileId = idbEditInfo.photoUseList[i].fileId;
                        photoUse.isUseI2 = idbEditInfo.photoUseList[i].useI2;
                        photoUse.idx = idbEditInfo.photoUseList[i].sonbpVp.idx;
                        photoUse.brightId = idbEditInfo.photoUseList[i].brightId;
                        photoUse.sonbpVp = idbEditInfo.photoUseList[i].sonbpVp;
                        editInfo.info.photoUse.push(photoUse);
                    }
                }
            }
        }
    }

// #endregion

// #region ■イベント

    // 写真では不要
    public btnClickStampMenu(event: JQueryEventObject) { }

    /**
     * ツールメニュー：画像入替・追加押下メソッド
     * @param selectedItemVp 選択済みアイテム（2025年対応：配置済み画像の再編集可能 #28295）
     * */
    public btnClickSetPhotoMenu(event: JQueryEventObject, selectedItemVp: itemVenderProperty = null): void {

        if (this._edctrl.editMode === EDIT_MODE_KIND.SET_PHOTO) {
            return;
        }

        let selectItem: itemVenderProperty = null;
        if (this._edctrl.editMode === EDIT_MODE_KIND.MANI_PHOTO) {
            // 選択アイテム取得
            selectItem = this.sonbpIfController.getSelectItem();

            Logger.debug("選択アイテム取得", selectItem);
        }
        else if (selectedItemVp !== null) {
            // 選択アイテム復元
            selectItem = selectedItemVp;

            Logger.debug("選択アイテム復元", selectItem);
        }

        if (this._usePcDesign) {
            // PC用
            // sonbpへ処理モード変更依頼
            this.sonbpIfController.setMode(EDIT_MODE_KIND.SET_PHOTO,
                () => {
                    // 正常終了の場合
                    this._edctrl.editMode = EDIT_MODE_KIND.SET_PHOTO;
                    // パネルの表示制御
                    this._vue.$data.Show.BalloonGuidance = true;
                    if (this._usePcDesign) {
                        this._vue.$data.Show.PhotoList = true;
                    }
                    this._vue.$data.Show.OparatePallet = true;
                    this._vue.$data.Show.GreetingPanel = false;
                    this._vue.$data.Show.SenderPanel = false;
                    this._vue.$data.Show.StampPanel = false;
                    this._vue.$data.Show.MyStampPanel = false;
                    this._vue.$data.Show.TegakiStampPanel = false;
                    this._vue.$data.Show.TegakiColorPanel = false;

                    // ツールメニューの活性制御
                    this._vue.$data.ActiveSetPhotoMenu = true;
                    this._vue.$data.ActiveManiPhotoMenu = false;
                    this._vue.$data.ActiveGreetingMenu = false;
                    this._vue.$data.ActiveSenderMenu = false;
                    this._vue.$data.ActiveStampMenu = false;
                    this._vue.$data.ActiveMyStampMenu = false;
                    this._vue.$data.ActiveTegakiStampMenu = false;
                    this._vue.$data.ActiveFinishSelectMenu = true;


                    // オブジェクト操作パレットの表示制御
                    this._edctrl.setModeOparatePallet(EDIT_MODE_KIND.SET_PHOTO, null);

                    // 選択アイテムの復元
                    if (selectItem !== null) {
                        this.sonbpIfController.selectItem(selectItem.item_type, selectItem.idx,
                            () => {
                                Logger.debug("選択アイテムの復元 成功");

                            },
                            () => {
                                Logger.error("選択アイテムの復元 失敗");
                            })
                    }
                    else {
                        // 先頭アイテムを選択
                        this.sonbpIfController.setSelectFirstItem(sonbpIfconst.ITYPE_PHOTO_BOX,
                            (selectItem: itemVenderProperty) => {
                            }, () => {
                            }, () => { });
                    }
                },
                () => {
                    // 異常終了の場合
                    util.dialogUtil.createErrorDialog(constDialogMessage.ERROR_EDIT_CHANGE_MODE, dialogUtil.closeErrorDialog, dialogUtil.DialogType.Warning);
                });
        } else {
            // SP用
            // sonbpへ処理モード変更依頼
            this.sonbpIfController.setMode(EDIT_MODE_KIND.SET_PHOTO,
                () => {
                    // 正常終了の場合
                    this._edctrl.editMode = EDIT_MODE_KIND.SET_PHOTO;
                    // タッチイベント制御(無効)
                    this._edctrl.touchEventChange(false);
                    // オブジェクト操作パレットの表示制御
                    this._edctrl.setModeOparatePallet(EDIT_MODE_KIND.SET_PHOTO, null);

                    // 選択アイテムの復元
                    if (selectItem !== null) {
                        this.sonbpIfController.selectItem(selectItem.item_type, selectItem.idx,
                            () => {
                                Logger.debug("選択アイテムの復元 成功");

                            },
                            () => {
                                Logger.error("選択アイテムの復元 失敗");
                            })
                    }
                    else {
                        // 先頭アイテムを選択
                        this.sonbpIfController.setSelectFirstItem(sonbpIfconst.ITYPE_PHOTO_BOX,
                            (selectItem: itemVenderProperty) => {
                            }, () => {
                            }, () => { });
                    }
                },
                () => {
                    // 異常終了の場合
                    util.dialogUtil.createErrorDialog(constDialogMessage.ERROR_EDIT_CHANGE_MODE, dialogUtil.closeErrorDialog, dialogUtil.DialogType.Warning);
                });
        }
    }

    /**
     * ツールメニュー：画像編集押下メソッド
     * @param selectedItemVp 選択済みアイテム（2025年対応：配置済み画像の再編集可能 #28295）
     * */
    public btnClickManiPhotoMenu(event: JQueryEventObject, selectedItemVp: itemVenderProperty = null): void {

        if (this._edctrl.editMode === EDIT_MODE_KIND.MANI_PHOTO) {
            return;
        }
        // 赤枠を消す
        this._vue.$data.Show.ImgGuidance = false;

        let selectItem: itemVenderProperty = null;
        if (this._edctrl.editMode === EDIT_MODE_KIND.SET_PHOTO) {
            // 選択アイテム取得
            selectItem = selectedItemVp ?? this.sonbpIfController.getSelectItem();

            Logger.debug("選択アイテム取得", selectItem);
        }
        else if (selectedItemVp !== null) {
            // 選択アイテム復元
            selectItem = selectedItemVp;

            Logger.debug("選択アイテム復元", selectItem);
        }

        if (this._usePcDesign) {
            // PC用
            // sonbpへ処理モード変更依頼
            this.sonbpIfController.setMode(EDIT_MODE_KIND.MANI_PHOTO,
                () => {
                    // 正常終了の場合
                    this._edctrl.editMode = EDIT_MODE_KIND.MANI_PHOTO;
                    // パネルの表示制御
                    this._vue.$data.Show.BalloonGuidance = false;
                    this._vue.$data.Show.PhotoList = false;
                    this._vue.$data.Show.OparatePallet = true;
                    this._vue.$data.Show.GreetingPanel = false;
                    this._vue.$data.Show.SenderPanel = false;
                    this._vue.$data.Show.StampPanel = false;
                    this._vue.$data.Show.MyStampPanel = false;
                    this._vue.$data.Show.TegakiStampPanel = false;

                    // ツールメニューの活性制御
                    this._vue.$data.ActiveSetPhotoMenu = false;
                    this._vue.$data.ActiveManiPhotoMenu = true;
                    this._vue.$data.ActiveGreetingMenu = false;
                    this._vue.$data.ActiveSenderMenu = false;
                    this._vue.$data.ActiveStampMenu = false;
                    this._vue.$data.ActiveMyStampMenu = false;
                    this._vue.$data.ActiveTegakiStampMenu = false;
                    this._vue.$data.ActiveFinishSelectMenu = false;

                    // オブジェクト操作パレットの表示制御
                    this._edctrl.setModeOparatePallet(EDIT_MODE_KIND.MANI_PHOTO, selectItem);

                    // 選択アイテムの復元
                    if (selectItem !== null) {
                        this.sonbpIfController.selectItem(selectItem.item_type, selectItem.idx,
                            () => {
                                Logger.debug("選択アイテムの復元 成功");
                                this.updPhotoCorrectCaption(selectItem);
                            },
                            () => {
                                Logger.error("選択アイテムの復元 失敗");
                            })
                    }
                    else {
                        // 先頭アイテムを選択
                        this.sonbpIfController.setSelectFirstItem(sonbpIfconst.ITYPE_PHOTO_BOX,
                            (selectItem: itemVenderProperty) => {
                                this.updPhotoCorrectCaption(selectItem);
                            },
                            () => { },
                            () => { });
                    }
                },
                () => {
                    // 異常終了の場合
                    util.dialogUtil.createErrorDialog(constDialogMessage.ERROR_EDIT_CHANGE_MODE, dialogUtil.closeErrorDialog, dialogUtil.DialogType.Warning);
                });
        }
        else {
            // SP用
            // sonbpへ処理モード変更依頼
            this.sonbpIfController.setMode(EDIT_MODE_KIND.MANI_PHOTO,
                () => {
                    // 正常終了の場合
                    this._edctrl.editMode = EDIT_MODE_KIND.MANI_PHOTO;

                    // タッチイベント制御(無効)
                    this._edctrl.touchEventChange(false);

                    // 履歴処理開始
                    this.sonbpIfController.historyStart();

                    // パネルの表示制御

                    // ツールメニューの活性制御

                    // タイトル
                    this._vue.$data.Header.Title = EditConst.TITLE_MANIPHOTO;

                    // 画像操作メニュー
                    this._vue.$data.Show.EditImageMenu = false;
                    // メインメニュー
                    this._vue.$data.Show.SetPhotoMenu = false;
                    // オブジェクト操作メニュー
                    this._vue.$data.Show.OparatePallet = true;

                    // 戻るボタン
                    this._vue.$data.Show.ReturnFlowBtn = false;
                    this._vue.$data.Show.ReturnHomeBtn = false;
                    this._vue.$data.Show.ReturnHomeExBtn = true;
                    // 次へボタン
                    this._vue.$data.Show.NextFlowBtn = false;
                    this._vue.$data.Show.CommitNextHomeBtn = true;

                    // タイトル
                    this._vue.$data.Header.Title = "画像調整";

                    // オブジェクト操作パレットの表示制御
                    this._edctrl.setModeOparatePallet(EDIT_MODE_KIND.MANI_PHOTO, selectItem);

                    // 選択アイテムの復元
                    if (selectItem !== null) {
                        this.sonbpIfController.selectItem(selectItem.item_type, selectItem.idx,
                            () => {
                                Logger.debug("選択アイテムの復元 成功");
                                this.updPhotoCorrectCaption(selectItem);
                            },
                            () => {
                                Logger.error("選択アイテムの復元 失敗");
                            })
                    }
                    else {
                        // 先頭アイテムを選択
                        this.sonbpIfController.setSelectFirstItem(sonbpIfconst.ITYPE_PHOTO_BOX,
                            (selectItem: itemVenderProperty) => {
                                this.updPhotoCorrectCaption(selectItem);
                            },
                            () => { },
                            () => { });
                    }
                },
                () => {
                    // 異常終了の場合
                    util.dialogUtil.createErrorDialog(constDialogMessage.ERROR_EDIT_CHANGE_MODE, dialogUtil.closeErrorDialog, dialogUtil.DialogType.Warning);
                });
        }
    }

    /**
     * 操作パネル→仕上がり選択(銀塩or印刷)ボタン押下メソッド
     * */
    public btnClickFinishSelect(doGinen: boolean, event: JQueryEventObject): void {

        this._vue.$data.FinishSelect.isGinen = doGinen ? true : false;

        // sonbpへ依頼
        this.sonbpIfController.setAreaView(doGinen ? sonbpIfconst.ATYPE_GINEN : sonbpIfconst.ATYPE_PRING);

    }

    /**
     * 操作パネル→画像補正する／しないボタン押下
     */
    public btnClickPhotoCorrect(event: JQueryEventObject): void {

        // カレントアイテム取得
        const selectItem: itemVenderProperty = this.sonbpIfController.getSelectItem();

        if (selectItem === null) {
            Logger.debug("アイテムが選択されていません");
            return;
        }

        // ローディングダイアログ開始
        util.dialogUtil.showLoading();

        Logger.debug("操作パネル→画像補正しないボタン押下メソッド", selectItem);

        // 対象画像情報取得
        const target: uploadPhoto = util.relic.listFind(this._uploadImageList, (up: uploadPhoto) => {
            return up.fileId === selectItem.file_id.split('@')[0];
        }, true);

        // 対象画像枠情報取得
        const targetFrame: photoFrame = util.relic.listFind(this.sonbpIfController.PhotoFrameList, (pf: photoFrame) => {
            return pf.idx === selectItem.idx;
        });

        let isUseI2ON = !targetFrame.useI2;
        let pureFileId = target.fileId;
        let vpFileId = isUseI2ON ? pureFileId + "@0" : pureFileId;

        // sonbpへ依頼
        this.sonbpIfController.setPhoto(vpFileId, target.width, target.height, isUseI2ON, true,
            () => {
                // 正常終了の場合
                targetFrame.fileId = pureFileId;
                targetFrame.useI2 = isUseI2ON;
                targetFrame.brightId = isUseI2ON ? 0 : 999;
                this._vue.$data.PhotoBright = 0;

                if (targetFrame.useI2) {
                    this._vue.$data.PhotoCorrectCaption = this._usePcDesign ? EditConst.PHOTO_CORRECT_CAPTION_PC_OFF : EditConst.PHOTO_CORRECT_CAPTION_SP_OFF;
                    this._vue.$data.Show.IsImageAutoFilter = true; // 補正あり
                    this._vue.$data.isBrightDownDisabled = false;
                    this._vue.$data.isBrightUpDisabled = false;
                    this._vue.$data.Show.OparatePalletBrightCover = false;
                }
                else {
                    this._vue.$data.PhotoCorrectCaption = this._usePcDesign ? EditConst.PHOTO_CORRECT_CAPTION_PC_ON : EditConst.PHOTO_CORRECT_CAPTION_SP_ON;
                    this._vue.$data.Show.IsImageAutoFilter = false; // 補正なし
                    this._vue.$data.isBrightDownDisabled = true;
                    this._vue.$data.isBrightUpDisabled = true;
                    this._vue.$data.Show.OparatePalletBrightCover = true;
                }

                util.dialogUtil.closeLoading();
            },
            () => {
                // 上記以外の場合
                util.dialogUtil.closeLoading();
            });
    }

    /**
     * 操作パネル→枠ぴったりＯＮ／ＯＦＦボタン押下
     */
    public btnClickPitaCorrect(doPita: boolean, event: JQueryEventObject): void {

        // ローディングダイアログ開始
        util.dialogUtil.showLoading();

        Logger.debug("操作パネル→画像枠ぴったりＯＮ／ＯＦＦボタン押下メソッド", doPita);

        // 枠ぴったり情報取得
        this.sonbpIfController.setPhotoWakuPita(doPita,
            () => {
                // 正常終了の場合
                this._vue.$data.Show.IsImagePita = doPita;
                util.dialogUtil.closeLoading();
            },
            () => {
                // 上記以外の場合
                util.dialogUtil.closeLoading();
            }
        );
    }

    /**
     * 操作パネル→編集の初期化ボタン押下
     */
    public btnClickEditClear(event: JQueryEventObject): void {

        // カレントアイテム取得
        const selectItem: itemVenderProperty = this.sonbpIfController.getSelectItem();
        // 結果判定
        if (selectItem === null) {
            Logger.debug("アイテムが選択されていません");
            return;
        }

        // ローディングダイアログ開始
        util.dialogUtil.showLoading();

        Logger.debug("操作パネル→編集の初期化ボタン押下メソッド", selectItem);

        // 対象画像情報取得
        const target: uploadPhoto = util.relic.listFind(this._uploadImageList, (up: uploadPhoto) => {
            return up.fileId === selectItem.file_id.split('@')[0];
        }, true);

        let isUseI2ON = this._edctrl.editInfo.master.design.editMode != EditConst.DSN_MST_EDIT_MODE_LIMIT;
        let pureFileId = target.fileId;
        let vpFileId = isUseI2ON ? pureFileId + "@0" : pureFileId;

        // sonbpへ依頼
        this.sonbpIfController.setPhoto(vpFileId, target.width, target.height, isUseI2ON, false,
            () => {
                // 正常終了の場合

                // 対象画像枠情報取得
                const targetFrame: photoFrame = util.relic.listFind(this.sonbpIfController.PhotoFrameList, (pf: photoFrame) => {
                    return pf.idx === selectItem.idx;
                });
                targetFrame.fileId = pureFileId;
                targetFrame.useI2 = isUseI2ON;
                targetFrame.brightId = isUseI2ON ? 0 : 999;
                this._vue.$data.PhotoCorrectCaption = this._usePcDesign ? EditConst.PHOTO_CORRECT_CAPTION_PC_OFF : EditConst.PHOTO_CORRECT_CAPTION_SP_OFF;
                this._vue.$data.Show.IsImageAutoFilter = true; // 補正あり(デフォルト)
                this._vue.$data.Show.IsImagePita = false; // 枠ぴったりＯＦＦ(デフォルト)
                this._vue.$data.PhotoBright = 0;
                this._vue.$data.isBrightDownDisabled = false;
                this._vue.$data.isBrightUpDisabled = false;
                this._vue.$data.Show.OparatePalletBrightCover = false;

                util.dialogUtil.closeLoading();
            },
            () => {
                // 上記以外の場合
                util.dialogUtil.closeLoading();
                util.dialogUtil.createErrorDialog(constDialogMessage.ERROR_EDIT_EDIT_CLEAR, dialogUtil.closeErrorDialog);
            });
    }

    /**
     * 操作パネル→フレームから削除ボタン押下
     */
    public btnClickRemovePhoto(event: JQueryEventObject): void {

        // 選択アイテム取得
        const selectItem: itemVenderProperty = this.sonbpIfController.getSelectItem();
        // 結果判定
        if (selectItem === null) {
            Logger.debug("アイテムが選択されていません");
            return;
        }

        Logger.debug("操作パネル→フレームから削除ボタン押下メソッド", selectItem);

        // sonbpへ依頼
        this.sonbpIfController.removePhotoByCurrent(
            () => {
                // 正常終了の場合

                // 対象画像枠情報取得
                const targetFrame: photoFrame = util.relic.listFind(this.sonbpIfController.PhotoFrameList, (pf: photoFrame) => {
                    return pf.idx === selectItem.idx;
                });
                targetFrame.fileId = "";
                targetFrame.useI2 = true;
                targetFrame.brightId = 0;
                this._vue.$data.PhotoCorrectCaption = this._usePcDesign ? EditConst.PHOTO_CORRECT_CAPTION_PC_OFF : EditConst.PHOTO_CORRECT_CAPTION_PC_ON;
                this._vue.$data.Show.IsImageAutoFilter = true; // 補正あり(デフォルト)
                this._vue.$data.Show.IsImagePita = false; // 枠ぴったりＯＦＦ(デフォルト)

                // 画像なしの枠になるのでオブジェクト操作パネルをカバー
                this._vue.$data.Show.OparatePalletCover = true;

                // 画像一覧の表示制御更新
                let remain: photoFrame = util.relic.listFind(this.sonbpIfController.PhotoFrameList, (pf: photoFrame) => {
                    return pf.fileId === selectItem.file_id.split('@')[0];
                });
                if (remain === undefined) {
                    for (let i: number = 0; i < this._uploadImageList.length; i++) {
                        if (this._uploadImageList[i].fileId === selectItem.file_id.split('@')[0]) {
                            this._uploadImageList[i].isUsed = false;
                            this._vue.$data.UploadPhotoList = this._uploadImageList;
                            this._vue.$data.PhotoBright = 0;
                            break;
                        }
                    }
                }

                // 次へボタンの活性制御
                this._edctrl.allowNextPage((allow: boolean) => {
                    this._vue.$data.EnableNextPageBtn = allow;
                });

                // SP用処理
                if (!this._usePcDesign) {
                    this.sonbpIfController.selectItemClear();
                }
            },
            () => {
                // 上記以外の場合
                util.dialogUtil.createErrorDialog(constDialogMessage.ERROR_EDIT_REMOVE_PHOTO, dialogUtil.closeErrorDialog);
            });
    }

    /**
     * 操作パネル→明るさ変更パネル表示（SP用）
     * */
    public btnClickManiChangeBright(event: JQueryEventObject): void {
        Logger.debug("操作パネル→明るさ変更パネル表示メソッド");
        if (this._edctrl.editMode === EDIT_MODE_KIND.MANI_PHOTO) {
            return;
        }
        this._vue.$data.Show.ImgGuidance = false;

        let selectItem: itemVenderProperty = null;
        if (this._edctrl.editMode === EDIT_MODE_KIND.SET_PHOTO) {
            // 選択アイテム取得
            selectItem = this.sonbpIfController.getSelectItem();

            Logger.debug("選択アイテム取得", selectItem);
        }

        // sonbpへ処理モード変更依頼
        this.sonbpIfController.setMode(EDIT_MODE_KIND.MANI_PHOTO,
            () => {
                // 正常終了の場合
                this._edctrl.editMode = EDIT_MODE_KIND.MANI_PHOTO;

                // タッチイベント制御(無効)
                this._edctrl.touchEventChange(false);

                // 履歴処理開始
                this.sonbpIfController.historyStart();

                // パネルの表示制御

                // ツールメニューの活性制御

                // タイトル
                this._vue.$data.Header.Title = EditConst.TITLE_CHANGE_BRIGHT;

                // 画像操作メニュー
                this._vue.$data.Show.EditImageMenu = false;
                // メインメニュー
                this._vue.$data.Show.SetPhotoMenu = false;
                // オブジェクト操作メニュー
                this._vue.$data.Show.OparatePallet = false;
                this._vue.$data.Show.OparatePalletChangeBright = true;

                // 戻るボタン
                this._vue.$data.Show.ReturnFlowBtn = false;
                this._vue.$data.Show.ReturnHomeBtn = false;
                this._vue.$data.Show.ReturnHomeExBtn = true;
                // 次へボタン
                this._vue.$data.Show.NextFlowBtn = false;
                this._vue.$data.Show.CommitNextHomeBtn = true;

                // オブジェクト操作パレットの表示制御
                this._edctrl.setModeOparatePallet(EDIT_MODE_KIND.MANI_PHOTO, selectItem);

                // 明るさ調整ボタンの活性制御
                if (this._vue.$data.PhotoBright > 9) {
                    this._vue.$data.isBrightUpDisabled = true;
                } else {
                    this._vue.$data.isBrightUpDisabled = false;
                }
                if (this._vue.$data.PhotoBright < -9) {
                    this._vue.$data.isBrightDownDisabled = true;
                } else {
                    this._vue.$data.isBrightDownDisabled = false;
                }

                // 選択アイテムの復元
                if (selectItem !== null) {
                    this.sonbpIfController.selectItem(selectItem.item_type, selectItem.idx,
                        () => {
                            Logger.debug("選択アイテムの復元 成功");
                            this.updPhotoCorrectCaption(selectItem);
                        },
                        () => {
                            Logger.error("選択アイテムの復元 失敗");
                        })
                }
                else {
                    // 先頭アイテムを選択
                    this.sonbpIfController.setSelectFirstItem(sonbpIfconst.ITYPE_PHOTO_BOX,
                        (selectItem: itemVenderProperty) => {
                            this.updPhotoCorrectCaption(selectItem);
                        },
                        () => { },
                        () => { });
                }
            },
            () => {
                // 異常終了の場合
                util.dialogUtil.createErrorDialog(constDialogMessage.ERROR_EDIT_CHANGE_MODE, dialogUtil.closeErrorDialog, dialogUtil.DialogType.Warning);
            });

    }

    /**
     * 操作パネル→明るさ変更メソッド
     * */
    public async btnClickChangeBright(bright: boolean, event: JQueryEventObject): es6promise.Promise<void> {
        Logger.debug("操作パネル→明るさ変更ボタン押下メソッド", bright);

        // 赤枠を消す
        this._vue.$data.Show.ImgGuidance = false;

        // 念のため
        if (bright && this._vue.$data.PhotoBright > 9) { return; }
        if (!bright && this._vue.$data.PhotoBright < -9) { return; }

        if (bright) {
            this._vue.$data.PhotoBright++;
            if (this._vue.$data.PhotoBright > 9) {
                this._vue.$data.isBrightUpDisabled = true;
            }
            this._vue.$data.isBrightDownDisabled = false;
        }
        else {
            this._vue.$data.PhotoBright--;
            if (this._vue.$data.PhotoBright < -9) {
                this._vue.$data.isBrightDownDisabled = true;
            }
            this._vue.$data.isBrightUpDisabled = false;
        }

        var selectItem = this.sonbpIfController.getSelectItem();
        if (selectItem === null) {
            Logger.debug("アイテムが選択されていません");
            return;
        }

        // ローディングダイアログ開始
        util.dialogUtil.showLoading();

        // 対象画像情報取得
        var target: uploadPhoto = util.relic.listFind(this._uploadImageList, (up: uploadPhoto) => {
            return up.fileId === selectItem.file_id.split('@')[0];
        }, true);

        var brightNum = this._vue.$data.PhotoBright;
        var pureFileId = target.fileId;
        var gomi = await this.changePhotoBright(brightNum, pureFileId);
        var vpFileId = pureFileId + "@" + brightNum;

        this.sonbpIfController.setPhoto(vpFileId, target.width, target.height, true, true,
            () =>
            {
                // 正常終了の時
                const targetFrame: photoFrame = util.relic.listFind(this.sonbpIfController.PhotoFrameList, (pf: photoFrame) => {
                    return pf.idx === selectItem.idx;
                });
                //targetFrame.useI2 = true;
                targetFrame.brightId = brightNum;

                util.dialogUtil.closeLoading();
            },
            () =>
            {
                // エラーの時
                Logger.error("明るさ変更に失敗しました。");
                util.dialogUtil.closeLoading();
            });

    }


// #region  ■イベント（PCのみ処理）

    /**
     * 画像一覧→画像のドラッグ開始イベント
     */
    public onDragStartPhoto(event: DragEvent, fileId: string) {

        if (this._edctrl.editMode !== EDIT_MODE_KIND.SET_PHOTO || !this._vue.$data.UploadListModeSelect) {
            // 画像選択モードでない場合は終了
            return;
        }

        // 操作対象の画像情報を取得
        let target: uploadPhoto = util.relic.listFind(this._uploadImageList, (item: uploadPhoto) => {
            return item.fileId === fileId;
        }, true);
        if (!target) {
            return;
        }

        let isUseI2ON = this._edctrl.editInfo.master.design.editMode != EditConst.DSN_MST_EDIT_MODE_LIMIT;
        let pureFileId = target.fileId;
        let vpFileId = isUseI2ON ? pureFileId + "@0" : pureFileId;

        // sonbpへドラッグ開始を通知
        this.sonbpIfController.onDragStartPhoto(event, vpFileId, target.width, target.height,
            (vpList: itemVenderProperty[]) => {
                // ドロップが正常終了した場合

                // 画像補正状態の保持
                const selectItem: itemVenderProperty = this.sonbpIfController.getSelectItem();
                const targetFrame: photoFrame = util.relic.listFind(this.sonbpIfController.PhotoFrameList, (pf: photoFrame) => {
                    return pf.idx === selectItem.idx;
                });
                targetFrame.fileId = pureFileId;
                targetFrame.useI2 = isUseI2ON;
                targetFrame.brightId = isUseI2ON ? 0 : 999;

                for (let i: number = 0; i < this._uploadImageList.length; i++) {
                    // ベンダープロパティに一致する画像IDを検索
                    let vp: itemVenderProperty = util.relic.listFind(vpList, (item: itemVenderProperty) => {
                        return item.file_id?.split('@')[0] === this._uploadImageList[i].fileId;
                    });
                    // 使用中アイコンの表示制御
                    if (vp !== undefined) {
                        // 使用中
                        this._uploadImageList[i].isUsed = true;
                    }
                    else {
                        // 未使用
                        this._uploadImageList[i].isUsed = false;
                    }
                }

                // 次へボタンの活性制御
                this._edctrl.allowNextPage((allow: boolean) => {
                    this._vue.$data.EnableNextPageBtn = allow;
                });
            },
            () => {
                // ドロップが異常終了した場合
                util.dialogUtil.createErrorDialog(constDialogMessage.ERROR_EDIT_SET_PHOTO, dialogUtil.closeErrorDialog);
            });
    }

// #endregion

// #region ■イベント（SPのみ処理）

    /**
     * 操作メニュー：読込・配置押下メソッド(SP用)
     * @summary アップロード画像一覧を表示する。
     */
    public btnClickImageListMenu(event: JQueryEventObject): void {

        this.setShowFlgAllOFF();

        // 画像一覧を表示
        this._vue.$data.Header.Title = EditConst.TITLE_IMAGELIST;
        this._vue.$data.Show.PhotoList = true;
        this._vue.$data.Show.ReturnHomeBtn = true;
        this._vue.$data.Show.NextHomeFromImgListBtn = true;
        this._vue.$data.Show.PhotoDeleteBtn = true;
    }

    /**
     * 入替(or 入替終了)ボタン押下(SP)
     */
    public btnClickSwapItemMenu(doStwapStart: boolean, event: JQueryEventObject): void {

        Logger.debug("入替(or 入替終了)ボタン押下(SP) doStwapStart[" + doStwapStart + "]");

        if (doStwapStart) {
            // 開始
            this._vue.$data.Header.Title = EditConst.TITLE_SWAPPHOTO;

            const selectItem: itemVenderProperty = this.sonbpIfController.getSelectItem();
            this._vue.$data.SwatpItem.FromItem = selectItem.idx;
            this._vue.$data.SwatpItem.ToItem = "";

            this._vue.$data.Show.EditImageMenu = false;
            this._vue.$data.Show.MessageArea = true;
            this._vue.$data.Show.ReturnFlowBtn = false;
            this._vue.$data.Show.ReturnHomeFromSwapItemBtn = true;
            this._vue.$data.SwatpItem.doSwap = true;
        }
        else {
            // 終了
            this._vue.$data.Header.Title = EditConst.TITLE_MAIN;

            this._vue.$data.SwatpItem.FromItem = "";
            this._vue.$data.SwatpItem.ToItem = "";

            this._vue.$data.Show.EditImageMenu = false;
            this._vue.$data.Show.MessageArea = false;
            this._vue.$data.Show.ReturnFlowBtn = true;
            this._vue.$data.Show.ReturnHomeFromSwapItemBtn = false;
            this._vue.$data.Show.SetPhotoMenu = true;

            this._vue.$data.SwatpItem.doSwap = false;

            // 選択解除
            this.sonbpIfController.selectItemClear();
        }
    }

    /**
     * 操作メニュー：枠ぴったり設定ボタン押下(SP)
     */
    public btnClickEditImagePitaMenu(event: JQueryEventObject): void {

        this._vue.$data.Show.EditImagePitaMenu = true;
    }

    /**
     * 操作メニューへ戻る(SP)
     */
    public returnPhotoManiBtn(event: JQueryEventObject): void {

        this._vue.$data.Show.EditImagePitaMenu = false;
        // 「戻る」ボタン
        this._vue.$data.Show.ReturnHomeExBtn = true;
        this._vue.$data.Show.ReturnPhotoManiBtn = false;
    }

// #endregion

// #endregion

// #region ■内部関数

    // 写真では不要
    public setStampEditMode() { }

    /**
     * 引き剥がし対象のIDを抽出
     * @summary アップロード一覧から画像削除される際、Canvasに配置済みならそのfileIdを抽出する。
     * @override
     */
    protected getRemoveTargetIds(): string[] {

        let removeIds: string[] = [];
        let useItems: itemVenderProperty[] = [];

        // 配置済の画像取得
        this.sonbpIfController.getPhotoList(
            (list: itemVenderProperty[]) => {
                useItems = list;
            }, () => { });

        // 削除対象の画像IDを抽出
        let delListIds = Enumerable.from(this._uploadImageList)
            .where(row => row.reqDelete === true)
            .select(row => row.fileId);
        removeIds = Enumerable.from(useItems)
            .where(row => delListIds.indexOf(row.file_id.split('@')[0]) >= 0)
            .select(row => row.file_id).distinct().toArray();

        return removeIds;
    }

    /**
     * 画像削除依頼処理
     * @summary 一覧から選択画像を削除し、Canvasに配置済ならその配置も引きはがす。
     * @implements
     */
    public requestRemove(fileIds: string[]) {

        this.sonbpIfController.removePhotoById(fileIds,
            () => {
                Logger.debug("画像削除依頼処理 正常終了");
                // 正常終了の場合
                this.afterRemove();
            },
            () => {
                // 上記以外の場合
                util.dialogUtil.createErrorDialog(constDialogMessage.ERROR_EDIT_DEL_PHOTO, dialogUtil.closeErrorDialog, dialogUtil.DialogType.Warning);
            });

        // js側の変数つじつま合わせ
        for (var i = 0; i < fileIds.length; i++) {
            for (var j = 0; j < this.sonbpIfController.PhotoFrameList.length; j++) {
                if (fileIds[i] == this.sonbpIfController.PhotoFrameList[j].fileId) {
                    this.sonbpIfController.PhotoFrameList[j].fileId = "";
                    this.sonbpIfController.PhotoFrameList[j].useI2 = true;
                    this.sonbpIfController.PhotoFrameList[j].brightId = 0;
                }
            }
        }
    }

    /**
     * 画像削除後の処理
     * @summary 一覧の削除枠を詰めて空き枠を整理する。
     * @override
     */
    public afterRemove() {

        super.afterRemove();

        // 次へボタンの活性制御
        this._edctrl.allowNextPage((allow: boolean) => {
            this._vue.$data.EnableNextPageBtn = allow;
        });

        if (this._isPhotoFlg && this.NotEmptyUploadNum === 0) {
            // 削除して０件になった場合
            this._vue.$data.Show.FirstGuidance = true;
        }
    }

    /**
     * 画像設定処理(本体) 
     * @summary 選択された画像をCanvasへ配置する（実際の処理）
     * @implements
     */
    public setImageBody(fileId: string, targetPhoto: uploadPhoto, nextFun: () => void) {

        // 選択アイテム取得
        const selectItem: itemVenderProperty = this.sonbpIfController.getSelectItem();
        // 結果判定
        if (selectItem === null) {
            Logger.debug("アイテムが選択されていません");
            return;
        }

        // ローディングダイアログ開始
        util.dialogUtil.showLoading();

        let target: uploadPhoto;
        if (targetPhoto) {
            target = targetPhoto;
        }
        else {
            // 対象画像情報取得
            target = util.relic.listFind(this._uploadImageList, (up: uploadPhoto) => {
                return up.fileId === fileId;
            }, true);
        }

        let isUseI2ON = this._edctrl.editInfo.master.design.editMode != EditConst.DSN_MST_EDIT_MODE_LIMIT;
        let pureFileId = target.fileId;
        let vpFileId = isUseI2ON ? pureFileId + "@0" : pureFileId;

        // 画像選択モード
        // sonbpに画像設定指示(カレント画像枠)
        this.sonbpIfController.setPhoto(vpFileId, target.width, target.height, isUseI2ON, false,
            () => {
                // 正常終了の場合

                // 次へボタンの活性制御
                this._edctrl.allowNextPage((allow: boolean) => {
                    this._vue.$data.EnableNextPageBtn = allow;
                });

                // 対象画像枠情報取得
                const targetFrame: photoFrame = util.relic.listFind(this.sonbpIfController.PhotoFrameList, (pf: photoFrame) => {
                    return pf.idx === selectItem.idx;
                });
                targetFrame.fileId = pureFileId;
                targetFrame.useI2 = isUseI2ON;
                targetFrame.brightId = isUseI2ON ? 0 : 999;
                this._vue.$data.PhotoCorrectCaption = this._usePcDesign ? EditConst.PHOTO_CORRECT_CAPTION_PC_OFF : EditConst.PHOTO_CORRECT_CAPTION_SP_OFF;
                this._vue.$data.Show.IsImageAutoFilter = true; // 補正あり
                this._vue.$data.Show.IsImagePita = false; // 枠ぴったりＯＦＦ

                // 画像枠間の入れ替えを考慮して全画像枠をチェック
                this.sonbpIfController.getItems([sonbpIfconst.ITYPE_PHOTO_BOX],
                    (list: itemVenderProperty[]) => {
                        for (let i: number = 0; i < this._uploadImageList.length; i++) {
                            if (this._uploadImageList[i].isEmpty || this._uploadImageList[i].deleteFlg) {
                                continue;
                            }

                            let targetFrame: itemVenderProperty = util.relic.listFind(list, (vp: itemVenderProperty) => {
                                return vp.file_id?.split('@')[0] === this._uploadImageList[i].fileId;
                            });

                            if (targetFrame !== undefined) {
                                let isUsed: boolean = (targetFrame.file_id === this.sonbpIfController.EMPTY_PHOTOBOX_FILE_ID) ? false : true;
                                this._uploadImageList[i].isUsed = isUsed;
                                this._vue.$data.UploadPhotoList[i].isUsed = isUsed;
                            }
                            else {
                                this._uploadImageList[i].isUsed = false;
                                this._vue.$data.UploadPhotoList[i].isUsed = false;
                            }
                        }

                        if (this._usePcDesign) {
                            // PC用(SPの場合、空き枠選択＝画像一覧に遷移となるためＮＧ)

                            // 次の空き画像枠があればそれを選択
                            const emptyPhotoFrames: photoFrame = util.relic.listFind(this.sonbpIfController.PhotoFrameList, (pf: photoFrame) => {
                                if (pf.fileId == "") {
                                    return true;
                                }
                                return false;
                            });
                            if (emptyPhotoFrames) {
                                this.sonbpIfController.selectItem(sonbpIfconst.ITYPE_PHOTO_BOX
                                    , emptyPhotoFrames.idx
                                    , () => { }
                                    , () => { }
                                );
                            }
                            util.dialogUtil.closeLoading();
                        }
                        else {
                            // SP用
                            // 選択アイテムの解除
                            this.sonbpIfController.selectItemClear();
                            util.dialogUtil.closeLoading();
                        }

                        // 追加処理
                        if (nextFun) {
                            nextFun();
                        }
                    },
                    () => {
                        util.dialogUtil.closeLoading();
                    });
            },
            () => {
                // 異常終了の場合
                util.dialogUtil.closeLoading();
                util.dialogUtil.createErrorDialog(constDialogMessage.ERROR_EDIT_SET_PHOTO, dialogUtil.closeErrorDialog);
            });

    }

    /**
     * 有効なアップロードファイルであるかのチェック
     * @summary ファイルのサイズ・MIMEチェックを行う。
     * @implements
     */
    public uploadFileValid(file: File): string {

        Logger.debug("アップロード前ファイルチェック type[" + file.type + "] size[" + file.size + "]");

        // MIMEタイプチェック
        if (typeof file === 'undefined' || typeof file.type === 'undefined') {
            return file.name + "：" + constDialogMessage.WARN_EDIT_PHOTO_FORMAT_CHECK;
        }
        if (file.type.length !== 0 &&
            file.type !== 'image/jpeg' &&
            file.type !== 'image/pjpeg') {
            return file.name + "：" + constDialogMessage.WARN_EDIT_PHOTO_FORMAT_CHECK;
        }

        // サイズ(容量チェック)
        if ((this._edctrl.ScreenCtrl.photoUlFileSizeMax * 1024 * 1024) < file.size) {
            return file.name + "：" + constDialogMessage.WARN_EDIT_PHOTO_SIZE_CHECK;
        }

        return "";
    }

    /**
     * アップロード一覧情報をWebStorageへ保存する。
     * @implements
     */
    public writeStorage(list: idbEdit.photo[]): boolean {

        return editStrage.writeStorageToPhoto(list);
    }

    // 写真では不要
    public callSonbpIfSetStamp(idx: number, target: uploadPhoto, okFunc: () => void, errFunc: () => void): void { }

    /**
     * 選択画像枠の状態で画像補正ボタンのキャプションを変更
     * @param selectItem    :選択画像枠(PHOTO_BOX)
     */
    private updPhotoCorrectCaption(selectItem: itemVenderProperty) {

        const targetFrame: photoFrame = util.relic.listFind(this.sonbpIfController.PhotoFrameList, (pf: photoFrame) => {
            return pf.idx === selectItem.idx;
        });

        if (targetFrame !== undefined) {
            if (targetFrame.useI2) {
                this._vue.$data.PhotoCorrectCaption = this._usePcDesign ? EditConst.PHOTO_CORRECT_CAPTION_PC_OFF : EditConst.PHOTO_CORRECT_CAPTION_SP_OFF;
                this._vue.$data.Show.IsImageAutoFilter = true; // 補正あり
            }
            else {
                this._vue.$data.PhotoCorrectCaption = this._usePcDesign ? EditConst.PHOTO_CORRECT_CAPTION_PC_ON : EditConst.PHOTO_CORRECT_CAPTION_SP_ON;
                this._vue.$data.Show.IsImageAutoFilter = false; // 補正なし
            }
        }
    }

    private async changePhotoBright(bright: number, fileId: string): es6promise.Promise<string> {

        let result: GetEditInfo.ChangeBright;

        // 入力パラメータ
        const param = {
            token: this._authToken,
            bright: bright,
            fileId: fileId
        }
        await util.ajax.post(this.WEBAPI_URL_CHANGEBRIGHT, JSON.stringify(param)).then((resData: GetEditInfo.ChangeBright) => {
            result = resData;

            Logger.debug("WebAPI_ChangeBright  result[" + JSON.stringify(result) + "]");

        }).catch(() => {
            result = null;
        });

        return result.fileId;
    }

// #endregion

}
